import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=0a80988a&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=0a80988a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80988a",
  null
  
)

export default component.exports